import {Image as ImageNext} from './Image';

export default ImageNext;
